import { Component } from 'js/lib/components/component'

class AmountFormCoverFees extends Component {
  initialize() {
    this.feeRate = parseFloat(this.element.dataset.feeRate) || 0.026
    this.feeFlat = parseFloat(this.element.dataset.feeFlat) || 0.37
    this.otherItemsAmount = parseFloat(this.element.dataset.otherItemsAmount) || 0
    this.label = this.element.querySelector('.js-c-cover-fees__label')
    this.form = this.element.closest('form')

    if (!this.form) return

    // Frequency changes can select a different suggested amount too.
    this.form.addEventListener('change', (e) => {
      if (e.target.name?.includes('amount') || e.target.name?.includes('frequency')) {
        this.updateFeeDisplay()
      }
    })

    // Also listen for input events on amount fields (e.g. custom amount typing)
    this.form.addEventListener('input', (e) => {
      if (e.target.name?.includes('amount')) {
        this.updateFeeDisplay()
      }
    })

    // Set initial state
    this.updateFeeDisplay()
  }

  getSelectedAmount() {
    if (!this.form) return 0

    const customAmountRadio = this.form.querySelector('.js-c-custom-amount-radio:checked')
    if (customAmountRadio) {
      const customAmountInput = this.form.querySelector('.js-c-custom-amount-value:not(:disabled)')
      const customAmount = parseFloat(customAmountInput?.value)
      return Number.isFinite(customAmount) && customAmount > 0 ? customAmount : 0
    }

    const selectedAmount = this.form.querySelector('input[name*="amount"][type="radio"]:checked:not(:disabled)')
    const amount = parseFloat(selectedAmount?.value)
    return Number.isFinite(amount) && amount > 0 ? amount : 0
  }

  calculateFee(amount) {
    if (!amount || amount <= 0) return 0
    return (amount + this.otherItemsAmount) * this.feeRate + this.feeFlat
  }

  updateFeeDisplay() {
    const amount = this.getSelectedAmount()
    const fee = this.calculateFee(amount)

    if (this.label) {
      if (fee > 0) {
        this.label.textContent = `I'd like to add $${fee.toFixed(2)} to cover the platform fees so you can keep 100% of my donation.`
      } else {
        this.label.textContent = `Cover the platform fees so you can keep 100% of my donation.`
      }
    }
  }
}

AmountFormCoverFees.register('.js-c-cover-fees')

export { AmountFormCoverFees }
